var _a;
// tslint:disable
import { IdOrientation } from "../constants/IdOrientation";
import { IdAssetBundleBuildings } from "./IdAssetBundleBuildings";
import { IdAssetBundleBuildingsInitial } from "./IdAssetBundleBuildingsInitial";
import { IdAssetBundleFence } from "./IdAssetBundleFence";
import { IdAssetBundleCafe } from "./outskirts/IdAssetBundleCafe";
import { IdAssetBundleDoghouse } from "./outskirts/IdAssetBundleDoghouse";
import { IdAssetBundleExternalBarn } from "./outskirts/IdAssetBundleExternalBarn";
import { IdAssetBundleHarbor } from "./outskirts/IdAssetBundleHarbor";
import { IdAssetBundleLibrary } from "./outskirts/IdAssetBundleLibrary";
import { IdAssetBundleMarket } from "./outskirts/IdAssetBundleMarket";
import { IdAssetBundleNursery } from "./outskirts/IdAssetBundleNursery";
import { IdAssetBundlePier } from "./outskirts/IdAssetBundlePier";
import { IdAssetBundleThemedEvent } from "./outskirts/IdAssetBundleThemedEvent";
import { IdAssetBundleTournamentTent } from "./outskirts/IdAssetBundleTournamentTent";
import { IdAssetBundleWatertower } from "./outskirts/IdAssetBundleWatertower";
import { IdAssetBundleBalloon } from "./static/IdAssetBundleBalloon";
export var artConfigBuildingsOverrides = (_a = {
        /********** Fence **********/
        // <editor-fold desc="Fence">
        // <editor-fold desc="Dirt">
        dirtPiece: {
            assets: [
                {
                    anchor: [0, 0.85],
                    id: IdAssetBundleFence.ground_dirt_lane_single,
                    offset: [0, 0],
                },
            ],
            colliders: [],
        },
        dirtCorner_left: {
            assets: [
                {
                    anchor: [0.98, 0.56],
                    id: IdAssetBundleFence.ground_dirt_edge_horizontal,
                    offset: [0, 0],
                },
            ],
            colliders: [],
        },
        dirtCorner_right: {
            assets: [
                {
                    anchor: [0.98, 0.56],
                    id: IdAssetBundleFence.ground_dirt_edge_horizontal,
                    offset: [0, 0],
                },
            ],
            colliders: [],
        },
        dirtCorner_up: {
            assets: [
                {
                    anchor: [0.56, 0.02],
                    id: IdAssetBundleFence.ground_dirt_edge_vertical,
                    offset: [0, 0],
                },
            ],
            colliders: [],
        },
        dirtCorner_down: {
            assets: [
                {
                    anchor: [0.56, 0.02],
                    id: IdAssetBundleFence.ground_dirt_edge_vertical,
                    offset: [0, -12],
                },
            ],
            colliders: [],
        },
        // </editor-fold>
        // <editor-fold desc="Fence1">
        fencePiece1: {
            assets: [
                {
                    anchor: [0, 1],
                    id: IdAssetBundleFence.mainFarmFence_piece_1,
                    offset: [0, 0],
                },
            ],
            colliders: [
            // {
            //     offset: [0, 0],
            //     type: 2,
            //     points: [[-33, 16.5], [-33, -16.5], [264, -165], [264, -132]],
            // },
            ],
        },
        fenceGate1: {
            assets: [
                {
                    anchor: [0, 1],
                    id: IdAssetBundleFence.mainFarmFence_gate_1,
                    offset: [0, 0],
                },
            ],
            colliders: [
                {
                    offset: [0, 0],
                    type: 2,
                    points: [
                        [-33, 16.5],
                        [-33, -16.5],
                        [132, -99],
                        [132, -165],
                        [231, -214.5],
                        [231, -148.5],
                        [264, -165],
                        [264, -132],
                    ],
                },
            ],
        }
    },
    _a["fenceCornerPillar_" + IdOrientation.Down + "_1"] = {
        assets: [
            {
                anchor: [0.5, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_bottom_1,
                offset: [0, 16],
            },
        ],
        colliders: [],
    },
    _a["fenceCornerPillar_" + IdOrientation.Up + "_1"] = {
        assets: [
            {
                anchor: [0.5, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_top_1,
                offset: [0, 13],
            },
        ],
        colliders: [],
    },
    _a["fenceCornerPillar_" + IdOrientation.Left + "_1"] = {
        assets: [
            {
                anchor: [0, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_leftright_1,
                offset: [-19, 15],
            },
        ],
        colliders: [],
    },
    _a["fenceCornerPillar_" + IdOrientation.Right + "_1"] = {
        assets: [
            {
                anchor: [0, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_leftright_1,
                offset: [18, 15],
            },
        ],
        colliders: [],
    },
    _a["fencePillar_1"] = {
        assets: [
            {
                anchor: [0.5, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_small_1,
                offset: [0, 13],
            },
        ],
        colliders: [],
    },
    // </editor-fold>
    // <editor-fold desc="Fence2">
    _a.fencePiece2 = {
        assets: [
            {
                anchor: [0, 1],
                id: IdAssetBundleFence.mainFarmFence_piece_2,
                offset: [0, 0],
            },
        ],
        colliders: [
        // {
        //     offset: [0, 0],
        //     type: 2,
        //     points: [[-33, 16.5], [-33, -16.5], [264, -165], [264, -132]],
        // },
        ],
    },
    _a.fenceGate2 = {
        assets: [
            {
                anchor: [0, 1],
                id: IdAssetBundleFence.mainFarmFence_gate_2,
                offset: [0, 4],
            },
        ],
        colliders: [
            {
                offset: [0, 0],
                type: 2,
                points: [
                    [-33, 16.5],
                    [-33, -16.5],
                    [132, -99],
                    [132, -180],
                    [231, -229.5],
                    [231, -148.5],
                    [264, -165],
                    [264, -132],
                ],
            },
        ],
    },
    _a["fenceCornerPillar_" + IdOrientation.Down + "_2"] = {
        assets: [
            {
                anchor: [0.5, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_bottom_2,
                offset: [0, 8],
            },
        ],
        colliders: [],
    },
    _a["fenceCornerPillar_" + IdOrientation.Up + "_2"] = {
        assets: [
            {
                anchor: [0.5, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_top_2,
                offset: [0, 9],
            },
        ],
        colliders: [],
    },
    _a["fenceCornerPillar_" + IdOrientation.Left + "_2"] = {
        assets: [
            {
                anchor: [0, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_leftright_2,
                offset: [-20, 8],
            },
        ],
        colliders: [],
    },
    _a["fenceCornerPillar_" + IdOrientation.Right + "_2"] = {
        assets: [
            {
                anchor: [0, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_leftright_2,
                offset: [20, 8],
            },
        ],
        colliders: [],
    },
    _a["fencePillar_2"] = {
        assets: [
            {
                anchor: [0.5, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_small_2,
                offset: [-2, 8],
            },
        ],
        colliders: [],
    },
    // </editor-fold>
    // <editor-fold desc="Fence3">
    _a.fencePiece3 = {
        assets: [
            {
                anchor: [0, 1],
                id: IdAssetBundleFence.mainFarmFence_piece_3,
                offset: [0, 0],
            },
        ],
        colliders: [
        // {
        //     offset: [0, 0],
        //     type: 2,
        //     points: [[-33, 16.5], [-33, -16.5], [264, -165], [264, -132]],
        // },
        ],
    },
    _a.fenceGate3 = {
        assets: [
            {
                anchor: [0, 1],
                id: IdAssetBundleFence.mainFarmFence_gate_3,
                offset: [0, 4],
            },
        ],
        colliders: [
            {
                offset: [0, 0],
                type: 2,
                points: [
                    [-33, 16.5],
                    [-33, -16.5],
                    [132, -99],
                    [132, -180],
                    [231, -229.5],
                    [231, -148.5],
                    [264, -165],
                    [264, -132],
                ],
            },
        ],
    },
    _a["fenceCornerPillar_" + IdOrientation.Down + "_3"] = {
        assets: [
            {
                anchor: [0.5, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_bottom_3,
                offset: [0, 0],
            },
        ],
        colliders: [],
    },
    _a["fenceCornerPillar_" + IdOrientation.Up + "_3"] = {
        assets: [
            {
                anchor: [0.5, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_top_3,
                offset: [0, 5],
            },
        ],
        colliders: [],
    },
    _a["fenceCornerPillar_" + IdOrientation.Left + "_3"] = {
        assets: [
            {
                anchor: [0, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_leftright_3,
                offset: [-6, -1],
            },
        ],
        colliders: [],
    },
    _a["fenceCornerPillar_" + IdOrientation.Right + "_3"] = {
        assets: [
            {
                anchor: [0, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_leftright_3,
                offset: [6, -1],
            },
        ],
        colliders: [],
    },
    _a["fencePillar_3"] = {
        assets: [
            {
                anchor: [0.3, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_small_3,
                offset: [0, -1],
            },
        ],
        colliders: [],
    },
    // </editor-fold>
    // <editor-fold desc="Fence4">
    _a.fencePiece4 = {
        assets: [
            {
                anchor: [0, 1],
                id: IdAssetBundleFence.mainFarmFence_piece_4,
                offset: [0, 0],
            },
        ],
        colliders: [
        // {
        //     offset: [0, 0],
        //     type: 2,
        //     points: [[-33, 16.5], [-33, -16.5], [264, -165], [264, -132]],
        // },
        ],
    },
    _a.fenceGate4 = {
        assets: [
            {
                anchor: [0, 1],
                id: IdAssetBundleFence.mainFarmFence_gate_4,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [0, 0],
                type: 2,
                points: [
                    [-33, 16.5],
                    [-33, -16.5],
                    [132, -99],
                    [132, -180],
                    [231, -229.5],
                    [231, -148.5],
                    [264, -165],
                    [264, -132],
                ],
            },
        ],
    },
    _a["fenceCornerPillar_" + IdOrientation.Down + "_4"] = {
        assets: [
            {
                anchor: [0.5, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_bottom_4,
                offset: [0, 7],
            },
        ],
        colliders: [],
    },
    _a["fenceCornerPillar_" + IdOrientation.Up + "_4"] = {
        assets: [
            {
                anchor: [0.5, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_top_4,
                offset: [0, 14],
            },
        ],
        colliders: [],
    },
    _a["fenceCornerPillar_" + IdOrientation.Left + "_4"] = {
        assets: [
            {
                anchor: [0, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_leftright_4,
                offset: [-18, 11],
            },
        ],
        colliders: [],
    },
    _a["fenceCornerPillar_" + IdOrientation.Right + "_4"] = {
        assets: [
            {
                anchor: [0, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_leftright_4,
                offset: [18, 11],
            },
        ],
        colliders: [],
    },
    _a["fencePillar_4"] = {
        assets: [
            {
                anchor: [0.3, 0.9],
                id: IdAssetBundleFence.mainFarmFence_pillar_small_4,
                offset: [3, -1],
            },
        ],
        colliders: [],
    },
    // </editor-fold>
    // <editor-fold desc="Fence5">
    _a.fencePiece5 = {
        assets: [
            {
                anchor: [0, 1],
                id: IdAssetBundleFence.mainFarmFence_piece_5,
                offset: [0, 0],
            },
        ],
        colliders: [
        // {
        //     offset: [0, 0],
        //     type: 2,
        //     points: [[-33, 16.5], [-33, -16.5], [264, -165], [264, -132]],
        // },
        ],
    },
    _a.fenceGate5 = {
        assets: [
            {
                anchor: [0, 1],
                id: IdAssetBundleFence.mainFarmFence_gate_5,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [0, 0],
                type: 2,
                points: [
                    [-33, 16.5],
                    [-33, -16.5],
                    [132, -99],
                    [132, -180],
                    [231, -229.5],
                    [231, -148.5],
                    [264, -165],
                    [264, -132],
                ],
            },
        ],
    },
    _a["fenceCornerPillar_" + IdOrientation.Down + "_5"] = {
        assets: [
            {
                anchor: [0.5, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_bottom_5,
                offset: [0, 7],
            },
        ],
        colliders: [],
    },
    _a["fenceCornerPillar_" + IdOrientation.Up + "_5"] = {
        assets: [
            {
                anchor: [0.5, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_top_5,
                offset: [0, 14],
            },
        ],
        colliders: [],
    },
    _a["fenceCornerPillar_" + IdOrientation.Left + "_5"] = {
        assets: [
            {
                anchor: [0, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_leftright_5,
                offset: [-18, 11],
            },
        ],
        colliders: [],
    },
    _a["fenceCornerPillar_" + IdOrientation.Right + "_5"] = {
        assets: [
            {
                anchor: [0, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_leftright_5,
                offset: [18, 11],
            },
        ],
        colliders: [],
    },
    _a["fencePillar_5"] = {
        assets: [
            {
                anchor: [0.3, 0.9],
                id: IdAssetBundleFence.mainFarmFence_pillar_small_5,
                offset: [3, -1],
            },
        ],
        colliders: [],
    },
    // </editor-fold>
    // <editor-fold desc="Fence6">
    _a.fencePiece6 = {
        assets: [
            {
                anchor: [0, 1],
                id: IdAssetBundleFence.mainFarmFence_piece_6,
                offset: [0, 0],
            },
        ],
        colliders: [
        // {
        //     offset: [0, 0],
        //     type: 2,
        //     points: [[-33, 16.5], [-33, -16.5], [264, -165], [264, -132]],
        // },
        ],
    },
    _a.fenceGate6 = {
        assets: [
            {
                anchor: [0, 1],
                id: IdAssetBundleFence.mainFarmFence_gate_6,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [0, 0],
                type: 2,
                points: [
                    [-33, 16.5],
                    [-33, -16.5],
                    [132, -99],
                    [132, -180],
                    [231, -229.5],
                    [231, -148.5],
                    [264, -165],
                    [264, -132],
                ],
            },
        ],
    },
    _a["fenceCornerPillar_" + IdOrientation.Down + "_6"] = {
        assets: [
            {
                anchor: [0.5, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_bottom_6,
                offset: [0, 7],
            },
        ],
        colliders: [],
    },
    _a["fenceCornerPillar_" + IdOrientation.Up + "_6"] = {
        assets: [
            {
                anchor: [0.5, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_top_6,
                offset: [0, 14],
            },
        ],
        colliders: [],
    },
    _a["fenceCornerPillar_" + IdOrientation.Left + "_6"] = {
        assets: [
            {
                anchor: [0, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_leftright_6,
                offset: [-18, 11],
            },
        ],
        colliders: [],
    },
    _a["fenceCornerPillar_" + IdOrientation.Right + "_6"] = {
        assets: [
            {
                anchor: [0, 1],
                id: IdAssetBundleFence.mainFarmFence_pillar_big_leftright_6,
                offset: [18, 11],
            },
        ],
        colliders: [],
    },
    _a["fencePillar_6"] = {
        assets: [
            {
                anchor: [0.3, 0.9],
                id: IdAssetBundleFence.mainFarmFence_pillar_small_6,
                offset: [3, -1],
            },
        ],
        colliders: [],
    },
    // </editor-fold>
    // </editor-fold>
    /********** Production buildings **********/
    // <editor-fold desc="Windmill">
    _a.windmill1 = {
        assets: [
            {
                id: IdAssetBundleBuildingsInitial.windmill_1,
                offset: [3, -105],
            },
            {
                id: IdAssetBundleBuildingsInitial.windmill_blades_1,
                offset: [36, -138],
            },
        ],
        colliders: [
            {
                offset: [0, 0],
                radius: 118,
                type: 1,
            },
        ],
    },
    _a.windmill2 = {
        assets: [
            {
                id: IdAssetBundleBuildings.windmill_2,
                offset: [-8, -108],
            },
            {
                id: IdAssetBundleBuildingsInitial.windmill_blades_1,
                offset: [36, -130],
            },
        ],
        colliders: [
            {
                offset: [0, 0],
                points: [
                    [8, 122],
                    [168, 37],
                    [86, 4],
                    [64, -65],
                    [-48, -123],
                    [-87, -83],
                    [-89, -7],
                    [-155, 38],
                ],
                type: 2,
            },
        ],
    },
    _a.windmill3 = {
        assets: [
            {
                id: IdAssetBundleBuildings.windmill_3,
                offset: [-9, -128],
            },
            {
                id: IdAssetBundleBuildingsInitial.windmill_blades_1,
                offset: [39, -168],
            },
        ],
        colliders: [
            {
                offset: [0, 0],
                points: [
                    [9, 145],
                    [172, 57],
                    [78, 0],
                    [70, -76],
                    [-78, -112],
                    [-88, 12],
                    [-163, 61],
                ],
                type: 2,
            },
        ],
    },
    _a.windmill4 = {
        assets: [
            {
                id: IdAssetBundleBuildings.windmill_4,
                offset: [0, -135],
            },
            {
                id: IdAssetBundleBuildingsInitial.windmill_blades_1,
                offset: [33, -182],
            },
        ],
        colliders: [
            {
                offset: [0, 0],
                points: [
                    [1, 151],
                    [170, 67],
                    [65, -3],
                    [69, -72],
                    [-68, -138],
                    [-94, -15],
                    [-110, 26],
                    [-163, 69],
                ],
                type: 2,
            },
        ],
    },
    _a.windmill5 = {
        assets: [
            {
                id: IdAssetBundleBuildings.windmill_5,
                offset: [5, -154],
            },
            {
                id: IdAssetBundleBuildingsInitial.windmill_blades_1,
                offset: [38, -219],
            },
        ],
        colliders: [
            {
                offset: [0, 0],
                points: [
                    [-6, 173],
                    [166, 88],
                    [79, 41],
                    [65, 7],
                    [66, -88],
                    [-65, -156],
                    [-100, 4],
                    [-117, 44],
                    [-174, 85],
                ],
                type: 2,
            },
        ],
    },
    // </editor-fold>
    /*********** Outskirt buildings ***********/
    // <editor-fold desc="Market">
    _a.Market1 = {
        assets: [
            {
                id: IdAssetBundleMarket.Market_MainBack0,
                offset: [413, -56],
            },
            {
                id: IdAssetBundleMarket.Market_MainFront1,
                offset: [274, 7],
            },
        ],
        colliders: [
            {
                offset: [303, -72],
                points: [[-112, 84], [-5, 137], [186, 47], [117, -22]],
                type: 2,
            },
        ],
    },
    _a.Market2 = {
        assets: [
            {
                id: IdAssetBundleMarket.Market_MainBack1,
                offset: [473, -89],
            },
            {
                id: IdAssetBundleMarket.Market_MainFront1,
                offset: [274, 7],
            },
        ],
        colliders: [
            {
                offset: [303, -72],
                points: [[-112, 84], [-5, 137], [207, -22], [153, -53]],
                type: 2,
            },
        ],
    },
    _a.Market3 = {
        assets: [
            {
                id: IdAssetBundleMarket.Market_MainBack1,
                offset: [473, -89],
            },
            {
                id: IdAssetBundleMarket.Market_MainFront2,
                offset: [251, 2],
            },
        ],
        colliders: [
            {
                offset: [303, -72],
                points: [[-153, 69], [-5, 137], [207, -22], [153, -53]],
                type: 2,
            },
        ],
    },
    _a.Market4 = {
        assets: [
            {
                id: IdAssetBundleMarket.Market_MainBack2,
                offset: [474, -112],
            },
            {
                id: IdAssetBundleMarket.Market_MainFront2,
                offset: [251, 2],
            },
        ],
        colliders: [
            {
                offset: [303, -72],
                points: [[-153, 69], [-5, 137], [207, -22], [153, -53]],
                type: 2,
            },
        ],
    },
    _a.Market5 = {
        assets: [
            {
                id: IdAssetBundleMarket.Market_MainBack2,
                offset: [474, -112],
            },
            {
                id: IdAssetBundleMarket.Market_MainFront3,
                offset: [232, -9],
            },
        ],
        colliders: [
            {
                offset: [303, -72],
                points: [[-190, 49], [-5, 137], [207, -22], [153, -53]],
                type: 2,
            },
        ],
    },
    _a.Market6 = {
        assets: [
            {
                id: IdAssetBundleMarket.Market_MainBack3,
                offset: [409, -141],
            },
            {
                id: IdAssetBundleMarket.Market_MainFront3,
                offset: [232, -9],
            },
        ],
        colliders: [
            {
                offset: [303, -72],
                points: [[-190, 49], [-5, 137], [261, 3], [21, -109]],
                type: 2,
            },
        ],
    },
    _a.Market7 = {
        assets: [
            {
                id: IdAssetBundleMarket.Market_MainBack3,
                offset: [409, -141],
            },
            {
                id: IdAssetBundleMarket.Market_MainFront4,
                offset: [225, -21],
            },
        ],
        colliders: [
            {
                offset: [303, -72],
                points: [[-214, 35], [-5, 137], [261, 3], [21, -109]],
                type: 2,
            },
        ],
    },
    _a.Market8 = {
        assets: [
            {
                id: IdAssetBundleMarket.Market_MainBack4,
                offset: [399, -145],
            },
            {
                id: IdAssetBundleMarket.Market_MainFront4,
                offset: [225, -21],
            },
        ],
        colliders: [
            {
                offset: [303, -72],
                points: [[-214, 35], [-5, 137], [261, 3], [-5, -124]],
                type: 2,
            },
        ],
    },
    _a.Market9 = {
        assets: [
            {
                id: IdAssetBundleMarket.Market_MainBack4,
                offset: [399, -145],
            },
            {
                id: IdAssetBundleMarket.Market_FoodFront0,
                offset: [9, -142],
            },
            {
                id: IdAssetBundleMarket.Market_MainFront5,
                offset: [196, -34],
            },
        ],
        colliders: [
            {
                offset: [303, -72],
                points: [[-321, -47], [-5, 137], [261, 3], [5, -116]],
                type: 2,
            },
        ],
    },
    _a.Market10 = {
        assets: [
            {
                id: IdAssetBundleMarket.Market_FoodBack0,
                offset: [213, -201],
            },
            {
                id: IdAssetBundleMarket.Market_MainBack5,
                offset: [389, -151],
            },
            {
                id: IdAssetBundleMarket.Market_FoodFront0,
                offset: [9, -142],
            },
            {
                id: IdAssetBundleMarket.Market_MainFront5,
                offset: [196, -34],
            },
        ],
        colliders: [
            {
                offset: [303, -72],
                points: [[-334, -44], [-5, 137], [261, 3], [-51, -144]],
                type: 2,
            },
        ],
    },
    _a.Market11 = {
        assets: [
            {
                id: IdAssetBundleMarket.Market_FoodBack0,
                offset: [213, -201],
            },
            {
                id: IdAssetBundleMarket.Market_MainBack5,
                offset: [389, -151],
            },
            {
                id: IdAssetBundleMarket.Market_FoodFront1,
                offset: [-43, -122],
            },
            {
                id: IdAssetBundleMarket.Market_MainFront5,
                offset: [196, -34],
            },
        ],
        colliders: [
            {
                offset: [303, -72],
                points: [[-365, -51], [-5, 137], [261, 3], [-51, -144]],
                type: 2,
            },
        ],
    },
    _a.Market12 = {
        assets: [
            {
                id: IdAssetBundleMarket.Market_FoodBack1,
                offset: [199, -243],
            },
            {
                id: IdAssetBundleMarket.Market_MainBack5,
                offset: [389, -151],
            },
            {
                id: IdAssetBundleMarket.Market_FoodFront1,
                offset: [-43, -122],
            },
            {
                id: IdAssetBundleMarket.Market_MainFront5,
                offset: [196, -34],
            },
        ],
        colliders: [
            {
                offset: [303, -72],
                points: [[-365, -51], [-5, 137], [261, 3], [-100, -177]],
                type: 2,
            },
        ],
    },
    _a.Market13 = {
        assets: [
            {
                id: IdAssetBundleMarket.Market_FoodBack1,
                offset: [199, -243],
            },
            {
                id: IdAssetBundleMarket.Market_MainBack5,
                offset: [389, -151],
            },
            {
                id: IdAssetBundleMarket.Market_FoodFront2,
                offset: [-49, -126],
            },
            {
                id: IdAssetBundleMarket.Market_MainFront5,
                offset: [196, -34],
            },
        ],
        colliders: [
            {
                offset: [303, -72],
                points: [[-365, -51], [-5, 137], [261, 3], [-100, -177]],
                type: 2,
            },
        ],
    },
    _a.Market14 = {
        assets: [
            {
                id: IdAssetBundleMarket.Market_FoodBack2,
                offset: [156, -256],
            },
            {
                id: IdAssetBundleMarket.Market_MainBack5,
                offset: [389, -151],
            },
            {
                id: IdAssetBundleMarket.Market_FoodFront2,
                offset: [-49, -126],
            },
            {
                id: IdAssetBundleMarket.Market_MainFront5,
                offset: [196, -34],
            },
        ],
        colliders: [
            {
                offset: [303, -72],
                points: [[-365, -51], [-5, 137], [261, 3], [-174, -217]],
                type: 2,
            },
        ],
    },
    _a.Market15 = {
        assets: [
            {
                id: IdAssetBundleMarket.Market_FoodBack2,
                offset: [156, -256],
            },
            {
                id: IdAssetBundleMarket.Market_MainBack5,
                offset: [389, -151],
            },
            {
                id: IdAssetBundleMarket.Market_FoodFront3,
                offset: [-42, -136],
            },
            {
                id: IdAssetBundleMarket.Market_MainFront5,
                offset: [196, -34],
            },
        ],
        colliders: [
            {
                offset: [303, -72],
                points: [[-389, -62], [-5, 137], [261, 3], [-174, -217]],
                type: 2,
            },
        ],
    },
    _a.Market16 = {
        assets: [
            {
                id: IdAssetBundleMarket.Market_FoodBack3,
                offset: [152, -256],
            },
            {
                id: IdAssetBundleMarket.Market_MainBack5,
                offset: [389, -151],
            },
            {
                id: IdAssetBundleMarket.Market_FoodFront4,
                offset: [-40, -144],
            },
            {
                id: IdAssetBundleMarket.Market_MainFront5,
                offset: [196, -34],
            },
        ],
        colliders: [
            {
                offset: [303, -72],
                points: [[-402, -76], [-5, 137], [261, 3], [-174, -217]],
                type: 2,
            },
        ],
    },
    _a.Market17 = {
        assets: [
            {
                id: IdAssetBundleMarket.Market_FlowerBack0,
                offset: [-3, -290],
            },
            {
                id: IdAssetBundleMarket.Market_FoodBack4,
                offset: [152, -256],
            },
            {
                id: IdAssetBundleMarket.Market_MainBack5,
                offset: [389, -151],
            },
            {
                id: IdAssetBundleMarket.Market_FoodFront4,
                offset: [-40, -144],
            },
            {
                id: IdAssetBundleMarket.Market_MainFront5,
                offset: [196, -34],
            },
        ],
        colliders: [
            {
                offset: [303, -72],
                points: [[-402, -76], [-5, 137], [261, 3], [-261, -257]],
                type: 2,
            },
        ],
    },
    _a.Market18 = {
        assets: [
            {
                id: IdAssetBundleMarket.Market_FlowerBack0,
                offset: [-3, -290],
            },
            {
                id: IdAssetBundleMarket.Market_FoodBack4,
                offset: [152, -256],
            },
            {
                id: IdAssetBundleMarket.Market_MainBack5,
                offset: [389, -151],
            },
            {
                id: IdAssetBundleMarket.Market_FlowerFront0,
                offset: [-210, -223],
            },
            {
                id: IdAssetBundleMarket.Market_FoodFront5,
                offset: [-53, -154],
            },
            {
                id: IdAssetBundleMarket.Market_MainFront5,
                offset: [196, -34],
            },
        ],
        colliders: [
            {
                offset: [303, -72],
                points: [[-576, -153], [-5, 137], [261, 3], [-261, -257]],
                type: 2,
            },
        ],
    },
    _a.Market27 = {
        assets: [
            {
                id: IdAssetBundleMarket.Market_FlowerBack4,
                offset: [-48, -340],
            },
            {
                id: IdAssetBundleMarket.Market_FoodBack4,
                offset: [152, -257],
            },
            {
                id: IdAssetBundleMarket.Market_MainBack5,
                offset: [389, -151],
            },
            {
                id: IdAssetBundleMarket.Market_FlowerFront5,
                offset: [-227, -247],
            },
            {
                id: IdAssetBundleMarket.Market_FoodFront5,
                offset: [-53, -154],
            },
            {
                id: IdAssetBundleMarket.Market_MainFront5,
                offset: [196, -34],
            },
        ],
        colliders: [
            {
                offset: [303, -72],
                points: [[-630, -166], [-5, 137], [261, 3], [-364, -300]],
                type: 2,
            },
        ],
    },
    // </editor-fold>
    // <editor-fold desc="Doghouse">
    _a.Doghouse1 = {
        assets: [{ id: IdAssetBundleDoghouse.Doghouse_1, offset: [0, 0] }],
        colliders: [
            {
                offset: [0, 0],
                radius: 100,
                type: 1,
            },
        ],
    },
    // </editor-fold>
    // <editor-fold desc="Watertower">
    _a.Watertower1 = {
        assets: [{ id: IdAssetBundleWatertower.Watertower_1, offset: [0, 0] }],
        colliders: [
            {
                offset: [-50, -150],
                size: [120, 300],
                type: 0,
            },
        ],
    },
    _a.Watertower2 = {
        assets: [{ id: IdAssetBundleWatertower.Watertower_2, offset: [0, 0] }],
        colliders: [
            {
                offset: [-50, -150],
                size: [120, 300],
                type: 0,
            },
        ],
    },
    _a.Watertower3 = {
        assets: [{ id: IdAssetBundleWatertower.Watertower_3, offset: [0, 0] }],
        colliders: [
            {
                offset: [-50, -150],
                size: [120, 300],
                type: 0,
            },
        ],
    },
    _a.Watertower4 = {
        assets: [{ id: IdAssetBundleWatertower.Watertower_4, offset: [0, 0] }],
        colliders: [
            {
                offset: [-50, -150],
                size: [120, 300],
                type: 0,
            },
        ],
    },
    _a.Watertower5 = {
        assets: [{ id: IdAssetBundleWatertower.Watertower_5, offset: [0, 0] }],
        colliders: [
            {
                offset: [-50, -150],
                size: [120, 300],
                type: 0,
            },
        ],
    },
    // </editor-fold>
    // <editor-fold desc="Nursery">
    _a.Nursery0 = {
        assets: [{ id: IdAssetBundleNursery.Nursery_0, offset: [0, 0] }],
        colliders: [
            {
                offset: [0, 0],
                radius: 140,
                type: 1,
            },
        ],
    },
    _a.Nursery1 = {
        assets: [{ id: IdAssetBundleNursery.Nursery_1, offset: [0, 0] }],
        colliders: [
            {
                offset: [0, 0],
                radius: 140,
                type: 1,
            },
        ],
    },
    _a.Nursery2 = {
        assets: [{ id: IdAssetBundleNursery.Nursery_2, offset: [0, 0] }],
        colliders: [
            {
                offset: [0, 0],
                radius: 140,
                type: 1,
            },
        ],
    },
    _a.Nursery3 = {
        assets: [{ id: IdAssetBundleNursery.Nursery_3, offset: [0, 0] }],
        colliders: [
            {
                offset: [0, 0],
                radius: 140,
                type: 1,
            },
        ],
    },
    _a.Nursery4 = {
        assets: [{ id: IdAssetBundleNursery.Nursery_4, offset: [0, 0] }],
        colliders: [
            {
                offset: [0, 0],
                radius: 140,
                type: 1,
            },
        ],
    },
    _a.Nursery5 = {
        assets: [{ id: IdAssetBundleNursery.Nursery_5, offset: [0, 0] }],
        colliders: [
            {
                offset: [0, 0],
                radius: 140,
                type: 1,
            },
        ],
    },
    _a.Nursery6 = {
        assets: [{ id: IdAssetBundleNursery.Nursery_6, offset: [0, 0] }],
        colliders: [
            {
                offset: [0, 0],
                radius: 140,
                type: 1,
            },
        ],
    },
    // </editor-fold>
    // <editor-fold desc="Library">
    _a.Library0 = {
        assets: [
            {
                anchor: [0.5, 1],
                id: IdAssetBundleLibrary.Library_0,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [64, -194],
                radius: 200,
                type: 1,
            },
        ],
    },
    _a.Library1 = {
        assets: [
            {
                anchor: [0.5, 1],
                id: IdAssetBundleLibrary.Library_1,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [64, -194],
                radius: 200,
                type: 1,
            },
        ],
    },
    _a.Library2 = {
        assets: [
            {
                anchor: [0.5, 1],
                id: IdAssetBundleLibrary.Library_2,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [64, -194],
                radius: 200,
                type: 1,
            },
        ],
    },
    _a.Library3 = {
        assets: [
            {
                anchor: [0.5, 1],
                id: IdAssetBundleLibrary.Library_3,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [64, -194],
                radius: 200,
                type: 1,
            },
        ],
    },
    _a.Library4 = {
        assets: [
            {
                anchor: [0.5, 1],
                id: IdAssetBundleLibrary.Library_4,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [64, -194],
                radius: 200,
                type: 1,
            },
        ],
    },
    _a.Library5 = {
        assets: [
            {
                anchor: [0.5, 1],
                id: IdAssetBundleLibrary.Library_5,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [64, -194],
                radius: 200,
                type: 1,
            },
        ],
    },
    _a.Library6 = {
        assets: [
            {
                anchor: [0.5, 1],
                id: IdAssetBundleLibrary.Library_6,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [64, -194],
                radius: 200,
                type: 1,
            },
        ],
    },
    _a.Library7 = {
        assets: [
            {
                anchor: [0.5, 1],
                id: IdAssetBundleLibrary.Library_7,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [64, -194],
                radius: 200,
                type: 1,
            },
        ],
    },
    // </editor-fold>
    // <editor-fold desc="External Barn">
    _a.ExternalBarn0 = {
        assets: [
            {
                anchor: [0.2846278, 0.8370098],
                id: IdAssetBundleExternalBarn.ExternalBarn_0,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -100],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.ExternalBarn1 = {
        assets: [
            {
                anchor: [0.2761824, 0.8370098],
                id: IdAssetBundleExternalBarn.ExternalBarn_1,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -100],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.ExternalBarn2 = {
        assets: [
            {
                anchor: [0.4209552, 0.8410948],
                id: IdAssetBundleExternalBarn.ExternalBarn_2,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -100],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.ExternalBarn3 = {
        assets: [
            {
                anchor: [0.3665904, 0.8390523],
                id: IdAssetBundleExternalBarn.ExternalBarn_3,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -100],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.ExternalBarn4 = {
        assets: [
            {
                anchor: [0.3708399, 0.8390523],
                id: IdAssetBundleExternalBarn.ExternalBarn_4,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -100],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.ExternalBarn5 = {
        assets: [
            {
                anchor: [0.3928151, 0.8390523],
                id: IdAssetBundleExternalBarn.ExternalBarn_5,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -100],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.ExternalBarn6 = {
        assets: [
            {
                anchor: [0.3939802, 0.8390523],
                id: IdAssetBundleExternalBarn.ExternalBarn_6,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -100],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.ExternalBarn7 = {
        assets: [
            {
                anchor: [0.4309409, 0.8390523],
                id: IdAssetBundleExternalBarn.ExternalBarn_7,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -100],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.ExternalBarn8 = {
        assets: [
            {
                anchor: [0.4405823, 0.8431373],
                id: IdAssetBundleExternalBarn.ExternalBarn_8,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -100],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.ExternalBarn9 = {
        assets: [
            {
                anchor: [0.4424317, 0.7634804],
                id: IdAssetBundleExternalBarn.ExternalBarn_9,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -100],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.ExternalBarn10 = {
        assets: [
            {
                anchor: [0.4612897, 0.7634804],
                id: IdAssetBundleExternalBarn.ExternalBarn_10,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -100],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.ExternalBarn11 = {
        assets: [
            {
                anchor: [0.4646789, 0.7022058],
                id: IdAssetBundleExternalBarn.ExternalBarn_11,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -100],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.ExternalBarn12 = {
        assets: [
            {
                anchor: [0.4769357, 0.7022058],
                id: IdAssetBundleExternalBarn.ExternalBarn_12,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -100],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.ExternalBarn13 = {
        assets: [
            {
                anchor: [0.4791383, 0.6858661],
                id: IdAssetBundleExternalBarn.ExternalBarn_13,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -100],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.ExternalBarn14 = {
        assets: [
            {
                anchor: [0.4680011, 0.6858661],
                id: IdAssetBundleExternalBarn.ExternalBarn_14,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -100],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.ExternalBarn15 = {
        assets: [
            {
                anchor: [0.4818691, 0.6858661],
                id: IdAssetBundleExternalBarn.ExternalBarn_15,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -100],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.ExternalBarn16 = {
        assets: [
            {
                anchor: [0.4870493, 0.6940361],
                id: IdAssetBundleExternalBarn.ExternalBarn_16,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -100],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.ExternalBarn17 = {
        assets: [
            {
                anchor: [0.4853736, 0.6654412],
                id: IdAssetBundleExternalBarn.ExternalBarn_17,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -100],
                radius: 220,
                type: 1,
            },
        ],
    },
    // </editor-fold>
    // <editor-fold desc="Harbor">
    _a.Harbor1 = {
        assets: [{ id: IdAssetBundleHarbor.Harbor_1, offset: [0, 0] }],
        colliders: [
            {
                type: 2,
                offset: [-440, -540],
                points: [
                    [168, 537],
                    [-2, 455],
                    [-2, 361],
                    [216, 251],
                    [406, 315],
                    [621, 296],
                    [824, 396],
                    [574, 532],
                    [393, 451],
                    [282, 534],
                ],
            },
        ],
    },
    // </editor-fold>
    // <editor-fold desc="PlayerLeague">
    _a.TournamentTent1 = {
        assets: [{ id: IdAssetBundleTournamentTent.TournamentTent_1, offset: [0, 0] }],
        colliders: [
            {
                offset: [-8, 0],
                radius: 170,
                type: 1,
            },
        ],
    },
    _a.TournamentTent2 = {
        assets: [{ id: IdAssetBundleTournamentTent.TournamentTent_2, offset: [0, 0] }],
        colliders: [
            {
                offset: [-8, 0],
                radius: 170,
                type: 1,
            },
        ],
    },
    // </editor-fold>
    // <editor-fold desc="ThemedEvent">
    _a.ThemedEventAsian = {
        assets: [{ id: IdAssetBundleThemedEvent.Asian, offset: [0, 0] }],
        colliders: [
            {
                offset: [-8, 0],
                radius: 200,
                type: 1,
            },
        ],
    },
    _a.ThemedEventCamping = {
        assets: [{ id: IdAssetBundleThemedEvent.Camping, offset: [0, 0] }],
        colliders: [
            {
                offset: [-8, 0],
                radius: 200,
                type: 1,
            },
        ],
    },
    _a.ThemedEventChristmas = {
        assets: [{ id: IdAssetBundleThemedEvent.Christmas, offset: [0, 0] }],
        colliders: [
            {
                offset: [-8, 0],
                radius: 200,
                type: 1,
            },
        ],
    },
    _a.ThemedEventEaster = {
        assets: [{ id: IdAssetBundleThemedEvent.Easter, offset: [0, 0] }],
        colliders: [
            {
                offset: [-8, 0],
                radius: 200,
                type: 1,
            },
        ],
    },
    _a.ThemedEventFairytale = {
        assets: [{ id: IdAssetBundleThemedEvent.Fairytale, offset: [0, 0] }],
        colliders: [
            {
                offset: [-8, 0],
                radius: 200,
                type: 1,
            },
        ],
    },
    _a.ThemedEventFoodTruck = {
        assets: [{ id: IdAssetBundleThemedEvent.FoodTruck, offset: [0, 0] }],
        colliders: [
            {
                offset: [-8, 0],
                radius: 200,
                type: 1,
            },
        ],
    },
    _a.ThemedEventFarmCup = {
        assets: [{ id: IdAssetBundleThemedEvent.FarmCup, offset: [0, 0] }],
        colliders: [
            {
                offset: [-8, 0],
                radius: 200,
                type: 1,
            },
        ],
    },
    _a.ThemedEventGeneric = {
        assets: [{ id: IdAssetBundleThemedEvent.Generic, offset: [0, 0] }],
        colliders: [
            {
                offset: [-8, 0],
                radius: 200,
                type: 1,
            },
        ],
    },
    _a.ThemedEventHalloween = {
        assets: [{ id: IdAssetBundleThemedEvent.Halloween, offset: [0, 0] }],
        colliders: [
            {
                offset: [-8, 0],
                radius: 200,
                type: 1,
            },
        ],
    },
    _a.ThemedEventHawaii = {
        assets: [{ id: IdAssetBundleThemedEvent.Hawaii, offset: [0, 0] }],
        colliders: [
            {
                offset: [-8, 0],
                radius: 200,
                type: 1,
            },
        ],
    },
    _a.ThemedEventUfo = {
        assets: [{ id: IdAssetBundleThemedEvent.Ufo, offset: [0, 0] }],
        colliders: [
            {
                offset: [-8, 0],
                radius: 200,
                type: 1,
            },
        ],
    },
    _a.ThemedEventWedding = {
        assets: [{ id: IdAssetBundleThemedEvent.Wedding, offset: [0, 0] }],
        colliders: [
            {
                offset: [-8, 0],
                radius: 200,
                type: 1,
            },
        ],
    },
    // </editor-fold>
    // <editor-fold desc="Pier">
    _a.Pier1 = {
        assets: [{ id: IdAssetBundlePier.Pier_1, offset: [0, 0] }],
        colliders: [
            {
                type: 2,
                offset: [-350, -200],
                points: [[165, 108], [351, 314], [501, 370], [686, 221], [363, 2]],
            },
        ],
    },
    // </editor-fold>
    // <editor-fold desc="Cafe and Store">
    _a.Cafe1 = {
        assets: [
            {
                id: IdAssetBundleCafe.Cafe_1,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -40],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.Cafe2 = {
        assets: [
            {
                id: IdAssetBundleCafe.Cafe_2,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -40],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.Cafe3 = {
        assets: [
            {
                id: IdAssetBundleCafe.Cafe_3,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -40],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.Cafe4 = {
        assets: [
            {
                id: IdAssetBundleCafe.Cafe_4,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -40],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.Cafe5 = {
        assets: [
            {
                id: IdAssetBundleCafe.Cafe_5,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -40],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.Cafe6 = {
        assets: [
            {
                id: IdAssetBundleCafe.Cafe_6,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -40],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.Cafe7 = {
        assets: [
            {
                id: IdAssetBundleCafe.Cafe_7,
                offset: [0, 0],
            },
        ],
        colliders: [
            {
                offset: [35, -40],
                radius: 220,
                type: 1,
            },
        ],
    },
    _a.Balloon1 = {
        assets: [
            {
                id: IdAssetBundleBalloon.Balloon_1,
                offset: [0, 0],
            },
            {
                id: IdAssetBundleBalloon.BalloonShadow,
                offset: [0, 300],
            },
        ],
        colliders: [
            {
                offset: [-110, -150],
                size: [220, 330],
                type: 0,
            },
        ],
    },
    _a);



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/artConfigBuildingsOverrides.ts
// module id = 2134
// module chunks = 3